export default {
  default: () => import("/home/runner/work/medicalclip-frontend/medicalclip-frontend/medicalclip-frontend/src/layouts/default.vue").then(m => m.default || m)
}